import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eraser } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const TestDataCleanup = ({ onDone }) => {
  const [c, setC] = useState(null);
  const load = () => api.get("/admin/test-data").then((r) => setC(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!c || (!c.orders && !c.customers)) return null;
  const run = async () => {
    const typed = window.prompt(`Elimina dati di prova: ${c.orders} ordini e ${c.customers} account con email ${c.domains.map((d) => `@${d}`).join(", ")}.\nGli ordini non ancora spediti restituiscono i pezzi allo stock. L'operazione non si può annullare.\n\nScrivi ELIMINA per confermare:`);
    if (typed === null) return;
    try {
      const { data } = await api.post("/admin/test-data/delete", { confirm: typed.trim() });
      toast.success(`Eliminati ${data.orders} ordini e ${data.customers} account di prova`, { description: `${data.stock_restored} pezzi tornati in magazzino` });
      load(); onDone?.();
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-2xl border border-dashed border-rose-300 bg-rose-50/60 px-4 py-3 text-sm" data-testid="test-data-panel">
      <Eraser className="h-4 w-4 text-rose-600" />
      <span>Dati di prova: <b data-testid="test-data-orders">{c.orders}</b> ordini e <b data-testid="test-data-customers">{c.customers}</b> account con email di test</span>
      <button onClick={run} className="ml-auto rounded-full bg-rose-600 px-4 py-1.5 text-xs font-bold text-white" data-testid="test-data-delete">Elimina dati di prova</button>
    </div>
  );
};
